import { getValidationResult } from './index';

const ISSUE = {
	TITLE_MIN_LENGTH: 3,
	TITLE_MAX_LENGTH: 100,
	DESCRIPTION_MIN_LENGTH: 3,
	DESCRIPTION_MAX_LENGTH: 8000
};

const ERROR_MESSAGES = {
	ISSUE: {
		POINTS: 'رتبه باید باید عدد صحیح مثبت باشند ',
		TITLE: `عنوان باید بیشتر از ${ISSUE.TITLE_MIN_LENGTH}
		 و کمتر از ${ISSUE.TITLE_MAX_LENGTH} کاراکتر باشد`,
		TITLE_REQUIRED: 'عنوان اجباری می باشد',
		DESCRIPTION_REQUIRED: 'توضیحات اجباری می باشد',
		DESCRIPTION: `توضیحات باید بیشتر از ${ISSUE.DESCRIPTION_MIN_LENGTH} و کمتر از ${ISSUE.DESCRIPTION_MAX_LENGTH} کاراکتر باشد`
	}
};

export const validateTitle = ({ Title }) => {
	if (!Title) {
		return getValidationResult(false, ERROR_MESSAGES.ISSUE.TITLE_REQUIRED);
	}

	const isValid = Title.length >= ISSUE.TITLE_MIN_LENGTH && Title.length <= ISSUE.TITLE_MAX_LENGTH;
	return getValidationResult(isValid, ERROR_MESSAGES.ISSUE.TITLE);
};

export const validatePoints = ({ StoryPoints }) => {
	if (!StoryPoints) {
		return true;
	}

	const isValid = Number.isInteger(+StoryPoints);
	return getValidationResult(isValid, ERROR_MESSAGES.ISSUE.POINTS);
};

export const validateDescription = ({ Description }) => {
	if (!Description) {
		return getValidationResult(false, ERROR_MESSAGES.ISSUE.DESCRIPTION_REQUIRED);
	}
	const isValid =
		Description.length >= ISSUE.DESCRIPTION_MIN_LENGTH && Description.length <= ISSUE.DESCRIPTION_MAX_LENGTH;
	return getValidationResult(isValid, ERROR_MESSAGES.ISSUE.DESCRIPTION);
};
